// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watchlist-navigation[data-v-6d1bbcfa]{position:sticky;max-width:1752px;margin:0 auto;padding:8px 15px;display:flex;flex-direction:row;top:104px;left:0;right:0;background:#060d17;z-index:100}@media(min-width:1050px){.watchlist-navigation[data-v-6d1bbcfa]{padding:8px 64px;top:56px}}", ""]);
// Exports
module.exports = exports;
